import React, { useState } from "react";
import * as ReactDOMServer from "react-dom/server";
import styles from "./Code.module.scss";

export default function Code(props) {
  const { value } = props;
  const [copied, setCopied] = useState(false);
  const onCopyHandler = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className={styles.container}>
      <pre>{value}</pre>
      <div className={styles.actions}>
        <button onClick={onCopyHandler} className={styles.copy}>
          {!copied ? "Сopy to clipboard" : "Copied"}
        </button>
      </div>
    </div>
  );
}

export function renderCodeComponent(props) {
  return ReactDOMServer.renderToString(<Code {...props} />);
}
